// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../../node_modules/postcss-loader/src/index.js??postcss!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageMatchItem.vue?vue&type=style&index=0&id=973de270&scoped=true&lang=css&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("62cabb16", content, true, {});